// src/components/Home-section.tsx
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const HomeSection: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <div className="w-full bg-white pb-4 md:pb-8">
        <section className="relative w-full bg-[#D6001C] pt-2 md:pt-4 pb-0 overflow-hidden font-sans">

          {/* 1. Latar Belakang Pola */}
          <div
            className="absolute inset-0 z-0 opacity-40 pointer-events-none"
            style={{
              backgroundImage: "url('/pattern-bg.png')",
              backgroundRepeat: 'repeat',
              backgroundSize: '300px',
              maskImage: 'linear-gradient(to right, transparent 0%, transparent 30%, black 100%)',
              WebkitMaskImage: 'linear-gradient(to right, transparent 0%, transparent 30%, black 100%)',
            }}
          ></div>

          {/* 2. IMAGE BARU (MERAH.PNG) - FULL HEIGHT
             Agar memanjang sampai bawah.
          */}
          <img
            src="/merah.png"
            alt="Decoration Right"
            // PERUBAHAN DI SINI:
            // 1. 'h-full': Membuat gambar setinggi section (mentok dari atas ke bawah).
            // 2. 'object-cover': Memastikan gambar mengisi area tanpa gepeng (opsional, bisa ganti object-contain jika ingin utuh).
            // 3. 'w-auto' atau 'w-1/2': Mengatur lebarnya agar proporsional.
            className="absolute top-0 right-0 z-0 w-auto h-full object-cover opacity-90 pointer-events-none"
          />

          {/* 3. Kontainer Konten Utama */}
          <div className="relative z-10 max-w-[85rem] mx-auto w-full px-4 md:px-8 grid md:grid-cols-2 gap-4 items-center">

            {/* KOLOM KIRI: TEKS */}
            <div className="text-left order-2 md:order-1 py-2 md:py-0" data-aos="fade-right">
              <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-white leading-tight tracking-tight">
                Your Journey to Learning <br className="hidden md:block" />
                Indonesian Starts Here
              </h1>
            </div>

            {/* KOLOM KANAN: KOMPOSISI GAMBAR */}
            <div
              className="relative flex justify-center md:justify-start items-end order-1 md:order-2 w-full h-[180px] md:h-[260px] md:-translate-x-12 self-end"
              data-aos="fade-left"
            >

               {/* IMAGE BACKGROUND (CARD) */}
               <img
                 src="/card.png"
                 alt="Background Decor"
                 className="absolute -bottom-2 md:-bottom-6 left-[42%] md:left-0 -translate-x-1/2 md:-translate-x-14 z-0 w-auto h-[180px] md:h-[320px] object-contain opacity-95 pointer-events-none"
               />

               {/* IMAGE UTAMA (ORANG) */}
               <img
                 src="/buku.png"
                 alt="Happy Student"
                 className="relative z-10 w-auto h-[300px] md:h-[340px] object-cover -bottom-10 md:-bottom-16 drop-shadow-xl"
               />

            </div>

          </div>
        </section>
      </div>
    </>
  );
};

export default HomeSection;